import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { map, head, tail, length, isEmpty, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { createElement } from "react";
import React from "react";
import { adminContent, ByCell, dateTimeCell, Labels } from "./Prelude.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/Facilities.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, Update } from "../Modals/Facility.fs.js";
import { Components_UnDelete, Components_Delete, Components_ChangeAttributes, Components_ChangeLabels } from "../Modals/Modal.fs.js";
import { Entity, DomainEntity } from "../ClientTypes.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(3, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, facility) {
    return new Row(facility.Id, ofArray([new Cell("name", facility.Name), new Cell("labels", createElement(Labels, {
        labels: facility.Labels,
    })), new Cell("lastModifiedOn", dateTimeCell(facility.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: facility.LastModifiedBy,
    }))]));
}

export function Facilities(facilitiesInputProps) {
    let actions, facilities, facilities_1;
    const projectId = facilitiesInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedFacilities = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Facilities",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (facilityParams) => many(projectId, empty(), facilityParams),
        fetchCount: (facilityParams_1) => count(projectId, facilityParams_1),
        rowRender: (facility) => rowRender(projectId, facility),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedFacilities);
    const isMoreThan1 = length(selectedFacilities) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_3) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedFacilities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Attributes"], ["onClick", (_arg_4) => {
        setAction("changeAttributes");
    }], ["disabled", isEmpty(selectedFacilities) ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_5) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedFacilities)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_6) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedFacilities)]])))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedFacilities) ? (isEmpty(tail(selectedFacilities)) ? createElement(Update, {
        projectId: projectId,
        facility: head(selectedFacilities),
        close: close,
    }) : undefined) : undefined) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map((facility_2) => [new DomainEntity(0, [facility_2]), facility_2.Labels], selectedFacilities),
        close: close,
    }) : ((actions === "changeAttributes") ? createElement(Components_ChangeAttributes, {
        projectId: projectId,
        entities: map((facility_3) => [new Entity(0, [facility_3]), facility_3.Attributes], selectedFacilities),
        close: close,
    }) : ((actions === "delete") ? ((facilities = map((Item) => (new DomainEntity(0, [Item])), selectedFacilities), createElement(Components_Delete, {
        projectId: projectId,
        entities: facilities,
        close: close,
    }))) : ((actions === "unDelete") ? ((facilities_1 = map((Item_1) => (new DomainEntity(0, [Item_1])), selectedFacilities), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: facilities_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))))))) : undefined);
}

